export const EUR_CURRENCY_SYMBOL = '€';
